(function () {
    'use strict';

    angular.module('swif.ui')
    .directive('swifRelated', swifRelated)
    .directive('swifNames', swifNames)
    .directive('swifMultiRelated', swifMultiRelated)
    .directive('swifNamesInline', swifNamesInline);


    /**
    * @ngdoc directive
    * @name swif.ui:swifRelated
    * @module swif.ui
    * @restrict E
    * @description display item in many2one relation
    * @usage 
    * <swif-related ng-model="item.many2oneRelation"></swif-related>
    **/
    function swifRelated() {
        'ngInject';
        return {
            restrict: 'E',
            scope: {
                ngModel: '=',
            },
            template: '<span>{{ngModel[1]}}</span>'
        };
    }

    /**
    * @ngdoc directive
    * @name swif.ui:swifNames
    * @module swif.ui
    * @restrict E
    * @description display names from a many2many relation
    * @usage 
    * <swif-names ng-model="item.relatedmany2many"></swif-names>
    **/
    function swifNames() {
        'ngInject';
        return {
            restrict: 'E',
            scope: {},
            require: 'ngModel',
            link: function (scope, element, attr, ngModel) {
                ngModel.$render = function () {
                    scope.names = [];
                    var vv = ngModel.$viewValue;
                    if (_.isArray(vv)) {
                        scope.names = vv.map((v) => {
                            return v[1];
                        }).join(', ');
                    }
                };
            },
            template: '<span class="swif-names">{{names}}</span>'
        };
    }

    /**
    * @ngdoc directive
    * @name swif.ui:swifMultiRelated
    * @module swif.ui
    * @restrict AE
    * @description
    * Display data from a many2many relation.
    * You must provide vocabulary or type
    * @usage 
    * <swif-multi-related
    *     type="user"
    *     ng-model="item.relatedmany2many"></swif-multi-related>
    **/
    function swifMultiRelated(dataService) {
        'ngInject';
        return {
            restrict: 'AE',
            scope: {
                vocabulary: '=?',
                type: '@?',
                display: '@'
            },
            replace: true,
            require: 'ngModel',
            link: function (scope, element, attr, ngModel) {
                scope.values = [];
                var updateValues = function () {
                    if (scope.display === 'csv') {
                        scope.values = scope.values.join(', ');
                    }
                };
                ngModel.$render = function () {
                    scope.values = [];
                    if (scope.display === undefined) {
                        scope.display = 'csv';
                    }
                    if (scope.vocabulary) {
                        var vocabulary = {};
                        _.forEach(scope.vocabulary, function (item) {
                            vocabulary[item.id] = item;
                        });
                        _.forEach(ngModel.$viewValue, function (itemId) {
                            if (vocabulary[itemId] !== undefined) {
                                scope.values.push(vocabulary[itemId].name);
                            }
                        });
                        updateValues();
                    } else if (scope.type && ngModel.$viewValue) {
                        var filter = {};
                        dataService.addFilter(filter, 'id', 'in', ngModel.$viewValue);
                        filter.fields = ['complete_name', 'name'];
                        dataService.get(scope.type, undefined, filter)
                        .then(function (items) {
                            scope.values = []; //fix async
                            _.forEach(items, function (item) {
                                scope.values.push(item.complete_name || item.name);
                            });
                            updateValues();
                        });
                    } else if (!ngModel.$viewValue) {
                        scope.values = '';
                    }
                };

            },
            templateUrl: 'partials/ui/multiRelated.html'
        };
    }


    /**
    * @ngdoc directive
    * @name swif.ui:swifNamesInline
    * @module swif.ui
    * @restrict E
    * @description 
    * @usage 
    /*
     This directive is uniquely used for field_names returned by OpenBase Odoo module
     input format is: [ [1, 'TEST'], [56, 'BLABLA']]
     output format is: <span tooltip="TEST, BLABLA">TEST, ...     <badge>2<span ng-transclude></span></badge><</span>
    **/
        
    function swifNamesInline() {
        return  {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                label: '=?'
            },
            link: function (scope, element, attrz, ngModel) {
                ngModel.$render = function () {
                    var data = ngModel.$viewValue;
                    scope.inlineData = [];
                    if(_.isArray(data)) {
                        _.forEach(data, function (item) {
                            scope.inlineData.push(item[1]);
                        });
                    }
                };
                scope.label = scope.label || 'Others';
            },
            templateUrl: 'partials/ui/swif_names_inline.html'
        };
    }

})();